// removed by extract-text-webpack-plugin
module.exports = {"tableContainer":"tableContainer___2BdzW","table":"table___1pliQ","expanded":"expanded___3r2gg","th":"th___Yl_Fx","tr":"tr___IMqlU","td":"td___1MsKV","clickable":"clickable___1KG_r","short":"short___wReYQ","centered":"centered___1V2pD"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Table/index.scss
// module id = 10
// module chunks = 0